/*
* Default managers/coordinator view for authenticated admin users
*/

import '@progress/kendo-ui';

import { Grid } from '@progress/kendo-grid-react-wrapper';
import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';
import { push } from 'react-router-redux';

import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { GridUtilities } from '../common/grid/gridutilities';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as ReduxQueries from '../queries';

export interface IDefaultManagersProps extends AppComp.IAppComponentProps {
    navigateTo?: any;
}

class DefaultManagers extends AppComp.AppComponent<IDefaultManagersProps, any> {
    public gridOptions = GridUtilities.kendoGridOptionsPaging(
        [
            GridUtilities.kendoGridColumnDefinition('regionName', this.appTextGridColumnHeader('region-name'), 80, 1),
            GridUtilities.kendoGridColumnDefinition('managerUsername', this.appTextGridColumnHeader('manager'), 90, 2),
            GridUtilities.kendoGridColumnDefinition('coordinatorUsername', this.appTextGridColumnHeader('coordinator'), 90, 3),
            GridUtilities.kendoGridColumnDefinition('editLink', '', 180, 4,
                                                    GridUtilities.kendoGridLinkColumnTemplate('editLink', 'editLinkHref', this.appText('edit-region-link')),
                                                    { headerTemplate: '' }),
        ],
        this.appText('no-results'), {}, this.appTextPageTitle()
    );

    public constructor(props: any) {
        super(props, 'app.default-managers.');
    }

    public composeUserName(record: any) {
        if (!record) { return ''; }

        return `${_.get(record, 'firstName')} ${_.get(record, 'lastName')} (${_.get(record, 'username')})`;
    }

    public extendGridData(records: Array<any>) {
        // Extend search result records with additional dynamic field values for use in grid
        if (!records) { return []; }

        return records.map( r => {
            let record = _.cloneDeep(r);

            record.regionName = _.get(record, 'name', '');
            record.managerUsername = this.composeUserName(_.get(record, 'defaultManager'));
            record.coordinatorUsername = this.composeUserName(_.get(record, 'defaultSiteInspector'));

            record.editLink = '';
            record.editLinkHref = '';
            if (record.name && record.regionId) {
                record.editLink = this.appText('edit-region-link');
                record.editLinkHref = NavigationLinks.regionEdit(Formatters.getInt(record, 'regionId'));
            }

            return record;
        });
    }

    public handleBackButton(e: any) {
        this.props.navigateTo(NavigationLinks.lookupTables());
    }

    public renderHeaderButtonToolbar() {
        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={3}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button bsSize="sm" bsStyle="info" onClick={e => { this.handleBackButton(e); }}><i className="fa fa-database" /> {this.appTextCommon('buttons.view-lookup-tables')}</Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public render() {
        const { search, ...rest } = this.props;

        const rows = this.extendGridData(search.results);
        const dataSource = GridUtilities.kendoGridDataSourcePaged(rows);

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);
        const page = (
            <div>
                <Row>
                    <Col xs={12} xl={9}>
                        <div>
                            {this.renderHeaderButtonToolbar()}
                        </div>
                    </Col>
                </Row>
                <WhiteBoxPageSection title={pageTitle}>
                    <Grid dataSource={dataSource} {...this.gridOptions} />
                </WhiteBoxPageSection>
            </div>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getDefaultManagersSearchUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.searchDefaultManagersRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
    _.get(props, 'search.operator', '')
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        search: {
            operator: 'OR',
            results: state.entities.defaultManagersResults,
        }
    });
};

const mapDispatchToProps = {
    navigateTo: (path) => push(path),
};

const DefaultManagersContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
  )(DefaultManagers);

export default withRouter(DefaultManagersContainer);



// WEBPACK FOOTER //
// ./src/default-managers/index.tsx